var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogoutIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.393 4.60291C13.0735 4.28344 12.5554 4.28339 12.2359 4.60286C11.9164 4.92239 11.9164 5.4404 12.2359 5.75993L14.6574 8.18153H4.63263C4.18078 8.18153 3.81445 8.54786 3.81445 8.99971C3.81445 9.45157 4.18078 9.81789 4.63263 9.81789H14.6573L12.2359 12.2393C11.9164 12.5588 11.9164 13.0768 12.2359 13.3963C12.3957 13.5561 12.6051 13.636 12.8145 13.636C13.0239 13.636 13.2333 13.5561 13.393 13.3963L17.211 9.57828C17.5306 9.2588 17.5306 8.74073 17.211 8.4212L13.393 4.60291Z",
    fill: "#494949",
    fillOpacity: 0.75
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.45401 18C8.90587 18 9.27219 17.6337 9.27219 17.1818C9.27219 16.73 8.90587 16.3636 8.45401 16.3636H2.18129V1.63636H8.45401C8.90587 1.63636 9.27219 1.27004 9.27219 0.818182C9.27219 0.366327 8.90587 0 8.45401 0H1.3631C0.911249 0 0.544922 0.366327 0.544922 0.818182V17.1818C0.544922 17.6337 0.911249 18 1.3631 18H8.45401Z",
    fill: "#494949",
    fillOpacity: 0.75
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoutIcon);
export default __webpack_public_path__ + "static/media/logout_icon.b2cdbdd102f7004d1912c67e2f1d8eaf.svg";
export { ForwardRef as ReactComponent };